
import { defineComponent, onMounted } from 'vue';
import { AppTable, AppCard, AppButton } from '@/components';
import { useSurpriseCategoryList } from '@/modules/surprise/category/model/list';
import { ROUTE_NAME_SURPRISE } from '@/modules/surprise/router';
import { TableColumnType, TableConfig } from '@/components/table/types';

export default defineComponent({
    name: ROUTE_NAME_SURPRISE.CATEGORY.INDEX,
    components: { AppTable, AppCard, AppButton },
    setup() {
        const { list, total, query, fetchList, actions } = useSurpriseCategoryList();

        const table: TableConfig = {
            columns: [
                { type: TableColumnType.Index, label: '#' },
                { type: TableColumnType.Text, label: 'Name', key: 'name' },
                { type: TableColumnType.Boolean, label: 'Is Published', key: 'isPublished' },
                { type: TableColumnType.Actions, label: 'Actions' }
            ],
            actions: [
                {
                    props: (row: any) => ({
                        icon: 'fa-edit',
                        theme: 'info',
                        tooltip: 'Edit',
                        to: { name: ROUTE_NAME_SURPRISE.CATEGORY.EDIT, params: { id: row.id } }
                    }),
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-leaf',
                        theme: 'info',
                        tooltip: 'View items',
                        to: { name: ROUTE_NAME_SURPRISE.CATEGORY.ITEM.INDEX, params: { categoryId: row.id } }
                    }),
                    group: 1
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-trash-alt',
                        theme: 'danger',
                        tooltip: 'Delete',
                        disabled: !row.canDelete,
                        onClick: () => actions.remove(row.id)
                    })
                }
            ]
        };

        onMounted(fetchList);

        return { table, list, total, query, fetchList, ROUTE_NAME_SURPRISE };
    }
});
